import { render } from "./AudioUploader.vue?vue&type=template&id=3e78feaa&scoped=true&ts=true"
import script from "./AudioUploader.vue?vue&type=script&lang=ts"
export * from "./AudioUploader.vue?vue&type=script&lang=ts"

import "./AudioUploader.vue?vue&type=style&index=0&id=3e78feaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e78feaa"]])

export default __exports__